import styled, { css, keyframes } from 'styled-components';

import { setAlpha } from '../../styles/utils';

const powerSearchGlowMove = keyframes`
  0%,
  100% {
    transform: translateX(-50%);
  }
  50% {
    transform: translateX(50%);
  }
`;

const powerSearchGlowSquash = keyframes`
  0%,
  50%,
  100% {
    scale: 1 1;
  }
  25%,
  75% {
    scale: 2 1;
  }
`;

const powerSearchInputLoadingGlow = css`
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  pointer-events: none;
  transform-origin: center center;
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    transparent 28%,
    ${({ theme }) => setAlpha(0.35, theme.colors.primary.lighten)} 42%,
    ${({ theme }) => setAlpha(0.55, theme.colors.gray['100'])} 50%,
    ${({ theme }) => setAlpha(0.35, theme.colors.primary.lighten)} 58%,
    transparent 72%,
    transparent 100%
  );
  background-size: 100% 100%;
  filter: drop-shadow(0 0 12px ${({ theme }) => setAlpha(0.75, theme.colors.blue.lighten)});
  animation:
    ${powerSearchGlowMove} 3s linear infinite,
    ${powerSearchGlowSquash} 3s linear infinite;
`;

export const PowerSearchInputLoadingGlow = styled.div<{ $active: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  flex-shrink: 0;
  height: ${({ $active }) => ($active ? '3px' : '0')};
  overflow: visible;
  visibility: ${({ $active }) => ($active ? 'visible' : 'hidden')};
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition:
    opacity 200ms ease,
    height 200ms ease,
    visibility 200ms ease;
  pointer-events: none;

  &::before {
    ${powerSearchInputLoadingGlow}
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
      left: 50%;
      scale: 1 1;
      transform: translateX(-50%);
    }
  }
`;
